import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractMultiSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-multi-select-column.component";
import {EntityData} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-membership-type-multi-select-column",
    templateUrl: "./membership-type-multi-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => MembershipTypeMultiSelectColumnComponent), multi: true}
    ]
})
export class MembershipTypeMultiSelectColumnComponent extends AbstractMultiSelectColumnComponent {
    EntityData = EntityData;

    @Input() includeGuestOption: boolean = false;

    constructor(injector: Injector) {
        super(injector, "membershipTypeId", "name");
    }
}
